// Copyright (c) StrangeBee 2023

import { ReactElement, memo } from 'react';
import { classList } from '@Helpers/className';
import { THMarkdown } from '@Molecules/Inputs/THMarkdown/THMarkdown';

import './MarkdownPreview.scss';

interface MarkdownPreviewProps {
    src: string;
    className?: string;
}

export const MarkdownPreview = memo(
    ({ src, className }: MarkdownPreviewProps): ReactElement => (
        <div className={classList('MarkdownPreview', className)}>
            <THMarkdown value={src} disabled borderless />
        </div>
    ),
);
